import { Box, List, ListItem, Typography } from '@mui/material';

import Description from 'components/CareSummary/Description';
import Empty from 'components/CareSummary/Empty';
import React from 'react';
import Title from 'components/CareSummary/Title';
import { Container } from 'shared-components/Container';
import { ChartGraphSkeleton } from '../ChartSkeleton';
import { useGetEHRCareTeamQuery } from 'store/api/pkd/endpoints/graphs';
import { useGetCurrentParticipantQuery } from 'store/api/pkd/endpoints/user';
import { groupDataByProperty } from 'utils/array';

const YourCareTeam = () => {
  const { data: person, isLoading: isPersonLoading } =
    useGetCurrentParticipantQuery();
  const personId = person?.id;
  const { careTeams, isFetching: isEHRDataLoading } = useGetEHRCareTeamQuery(
    { personId },
    {
      skip             : !personId,
      selectFromResult : ({ data, isLoading, isFetching }) => {
        const careTeams = data?.data?.careTeams?.items ?? [];
        const careTeamGroup =
          groupDataByProperty(careTeams, 'participantRoleText') ?? {};
        return {
          careTeams : careTeamGroup,
          isLoading,
          isFetching,
        };
      },
    }
  );

  const isLoading = isPersonLoading || isEHRDataLoading;
  const content = isLoading
    ? (
      <ChartGraphSkeleton />
    )
    : (
      <>
        {Object.keys(careTeams).length > 0
          ? (
            <>
              {Object.keys(careTeams).map((role, index) => (
                <Box
                  key={`${role}_${index}`}
                  display='flex' flexDirection='column'>
                  <Box
                    display='flex' flexDirection='column'>
                    <Typography
                      key={role} variant='pl1'>
                      {role}
                    </Typography>
                    <Typography
                      key={role} variant='pl1'>
                      {careTeams[role].map((careTeam, careTeamIndex) => (
                        <ListItem
                          key={careTeamIndex}
                          alignItems='flex-start'
                          sx={{ display: 'list-item' }}>
                          {careTeam.participantMemberDisplay}
                          {` (last visited ${careTeam.lastvisitedyear})`}
                        </ListItem>
                      ))}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </>
          )
          : (
            <Empty
              description='Link your health record data'
              to='/my-care-network'
              buttonText='Link your health record data'
            />
          )}
      </>
    );

  return (
    <Container>
      <Title>Your care team</Title>
      <Description>
        ADPKD can affect organs other than the kidneys. Potential issues include
        liver cysts, mitral valve prolapse, aneurysms, hernias, diverticulosis,
        and diabetes. You may see more than one specialist to manage these
        issues.
      </Description>
      {content}
    </Container>
  );
};

export default YourCareTeam;
